import { default as MuiCircularProgress, CircularProgressProps } from '@mui/material/CircularProgress'
import * as React from 'react'

export const CircularProgress = (props: CircularProgressProps) => {
  return <MuiCircularProgress {...props} color="secondary" />
}

export default CircularProgress
